export default __webpack_public_path__ + "static/media/no-results-image.9c82e833.svg";